import type { NextPage } from "next";

interface Props {
  color?: string;
}

const CarIcon: NextPage<Props> = ({ color = "#FFFFFF" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="34"
      height="26"
      viewBox="0 0 34 26"
      fill="none"
    >
      <path
        d="M4.51763 10.6889L4.41459 8.64867C4.39398 8.20045 4.14154 7.79859 3.74999 7.57706L1.6892 6.43332L0.334229 8.87535L4.41974 11.1474C4.49702 11.0134 4.53309 10.8537 4.52279 10.694"
        fill={color}
      />
      <path
        d="M29.4842 10.6889L29.5872 8.64867C29.6078 8.20045 29.8603 7.79859 30.2518 7.57706L32.3126 6.43332L33.6676 8.87535L29.582 11.1474C29.5048 11.0134 29.4687 10.8537 29.479 10.694"
        fill={color}
      />
      <path
        d="M17.0056 14.0737C10.2977 14.0737 4.50686 11.1834 4.41412 11.1422V24.5734C4.41412 25.1298 4.86751 25.5832 5.42392 25.5832H8.26265C8.53056 25.5832 8.78816 25.475 8.97879 25.2844L10.8902 23.3575C11.0808 23.1669 11.3384 23.0587 11.6063 23.0587H22.4048C22.6727 23.0587 22.9303 23.1669 23.121 23.3575L25.0324 25.2844C25.223 25.475 25.4806 25.5832 25.7485 25.5832H28.5872C29.1436 25.5832 29.597 25.1298 29.597 24.5734V11.1422C29.5043 11.1834 23.7186 14.0737 17.0056 14.0737Z"
        fill={color}
      />
      <path
        d="M29.597 11.1422L26.0833 2.20304C25.7742 1.13143 24.8005 0.410156 23.6928 0.410156H10.3183C9.22093 0.410156 8.2472 1.13143 7.92778 2.20304L4.41412 11.1422C4.50686 11.101 10.2925 8.21025 17.0056 8.21025C23.7186 8.21025 29.5043 11.101 29.597 11.1422Z"
        fill={color}
      />
    </svg>
  );
};

export default CarIcon;
